export default __webpack_public_path__ + "static/media/368.e33f0a10.gif";